import { NotificationType } from "@app/enumerations";

interface AppNotificationParams {
	title: string;
	primaryMessage: string;
	secondaryMessage?: string;
	type: NotificationType;
	timeout?: number;
}

export default class AppNotification {
	public title: string;
	public primaryMessage: string;
	public secondaryMessage?: string;
	public type: NotificationType;
	public timeout?: number;
	public id: string;

	public constructor(params: AppNotificationParams) {
		this.title = params.title;
		this.primaryMessage = params.primaryMessage;
		this.secondaryMessage = params.secondaryMessage;
		this.type = params.type;
		this.timeout = params.timeout;
		this.id = Math.random().toString(36).substr(2, 9);
	}
}